import createValueModule from "@/redux/create-value-module";

import { $ApiMessagesModuleName, TApiMessagesState } from "./apiMessages.types";

const { constants: _constants, actions } = createValueModule<TApiMessagesState>(
    $ApiMessagesModuleName,
    {
        data: null
    }
);

export const clear = actions.clear;
export const set = actions.set;
export const update = actions.update;

export const constants = _constants;
